var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media (min-width: 993px) {\n.searchForm[data-v-9f1d3ab0] {\n    margin-top: 0%;\n}\n}\n.milkyBlock.boxRequest.pull-right.new-button[data-v-9f1d3ab0] {\n  width: 125px;\n}\n.rowBackgroundImage[data-v-9f1d3ab0] {\n  background-image: url(" + escape(require("../../../assets/static/images/MenuFont.png")) + ");\n  background-size: contain;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9f1d3ab0","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/services/directDebit/SendboxPage.vue
// module id = 1158
// module chunks = 2